package com.narbase.letsgo.web.views.voiceassistant

import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.dependent.weightOf
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.lifecycle.LifecycleOwner
import com.narbase.letsgo.dto.dto
import com.narbase.letsgo.dto.enum
import com.narbase.letsgo.web.common.AppColors
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantConnectionHealthDto
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantSettingsDto
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantTranscriptionFallbackDto
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantEngine
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantField
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantEngineDecisionConfidence
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantMediumConfidenceAction
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantModelProvider
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantSpeechDetector
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantModelRole
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantModels
import com.narbase.letsgo.web.theme.theme
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.horizontalFiller
import com.narbase.letsgo.web.utils.scrollable.scrollable
import com.narbase.letsgo.web.utils.views.*
import com.narbase.letsgo.web.utils.views.customViews.CustomCheckBox
import com.narbase.letsgo.web.utils.views.customViews.customCheckBox
import com.narbase.letsgo.web.views.voiceassistant.VoiceAssistantManagementViewModel.EngineTestRecording
import com.narbase.letsgo.web.utils.views.input
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader
import org.w3c.files.get

class VoiceAssistantManagementComponent : Component() {

    private val viewModel = VoiceAssistantManagementViewModel()

    private var settingsForm: LinearLayout? = null
    private var saveStatusText: TextView? = null
    private var modelsHealthResults: LinearLayout? = null
    private var mcpHealthResult: LinearLayout? = null

    private var isEnabled = true
    private var isEnabledCheckBox: CustomCheckBox? = null
    private var engine = VoiceAssistantEngine.OPENAI
    private var enabledProfileGroupIdsInput: TextInput? = null
    private var introAudioUploader: AudioUploader? = null
    private var aiStandaloneSection: LinearLayout? = null
    private var openAiModelsSection: LinearLayout? = null
    private var aiStandaloneBaseUrlInput: TextInput? = null
    private var aiStandaloneApiKeyInput: TextInput? = null
    private var aiStandaloneHighConfidenceScoreInput: TextInput? = null
    private var aiStandaloneMediumConfidenceScoreInput: TextInput? = null
    private var aiStandaloneLowConfidenceScoreInput: TextInput? = null
    private var maxRecordingSecondsInput: TextInput? = null
    private var speechDetector = VoiceAssistantSpeechDetector.SILERO_MODEL
    private var isSendOnSilenceEnabled = true
    private var isRecordingTimerStartedOnSpeech = true
    private var isSilencedMicrophoneDetected = true
    private var isRouteConfirmationSkippedOnHighConfidence = false
    private var isRideBookedOnRouteConfirmation = false
    private var isOnlyDestinationInterpreted = false
    private var isAiStandaloneHintUsed = false
    private var aiStandaloneHintSection: LinearLayout? = null
    private var aiStandaloneHintPromptInput: TextArea? = null
    private var mediumConfidenceAction = VoiceAssistantMediumConfidenceAction.CONFIRM_ROUTE
    private var lowConfidenceAction = VoiceAssistantMediumConfidenceAction.TRANSFER_TO_CALL_CENTER
    private var aiStandaloneMediumConfidenceAction = VoiceAssistantMediumConfidenceAction.CONFIRM_ROUTE
    private var aiStandaloneLowConfidenceAction = VoiceAssistantMediumConfidenceAction.CONFIRM_ROUTE
    private var aiStandaloneConfirmConfidence = VoiceAssistantEngineDecisionConfidence.HIGH
    private var aiStandaloneHandoffConfidence = VoiceAssistantEngineDecisionConfidence.LOW
    private var aiStandaloneConfidenceSection: LinearLayout? = null
    private var openAiConfidenceActionsSection: LinearLayout? = null
    private var silenceSecondsBeforeSendInput: TextInput? = null
    private var candidatesCountInput: TextInput? = null
    private var searchResultsCountInput: TextInput? = null
    private var chatFields: VoiceAssistantModelEndpointFields? = null
    private var transcriptionFields: VoiceAssistantModelEndpointFields? = null
    private var transcriptionFallbackEntries = mutableListOf<TranscriptionFallbackEntry>()
    private var transcriptionFallbacksView: LinearLayout? = null
    private var transcriptionLanguage = VoiceAssistantModels.DEFAULT_TRANSCRIPTION_LANGUAGE
    private var transcriptionPromptInput: TextInput? = null
    private var maxInterpretationsPerDayInput: TextInput? = null
    private var maxAudioBytesInput: TextInput? = null
    private var audioRetentionHoursInput: TextInput? = null
    private var maxResponseTokensInput: TextInput? = null
    private var elasticsearchMcpUrlInput: TextInput? = null
    private var elasticsearchMcpToolNameInput: TextInput? = null
    private var openAiRequestTimeoutSecondsInput: TextInput? = null
    private var maxToolCallRoundsInput: TextInput? = null
    private var systemPromptInput: TextArea? = null
    private var dropoffRulesInput: TextArea? = null
    private var pickupRulesInput: TextArea? = null
    private var destinationOnlyRulesInput: TextArea? = null
    private var engineTestField = VoiceAssistantField.DROPOFF
    private var engineTestTextInput: TextInput? = null
    private var engineTestRecording: EngineTestRecording? = null
    private var engineTestRecordingName: TextView? = null
    private val engineTestResultDialog = VoiceAssistantSessionDetailsDialog(VoiceAssistantSessionsViewModel())

    override fun onViewCreated(lifecycleOwner: LifecycleOwner) {
        super.onViewCreated(lifecycleOwner)
    }

    override fun onViewMounted(lifecycleOwner: LifecycleOwner) {
        super.onViewMounted(lifecycleOwner)
        viewModel.getSettings()
    }

    override fun View?.getView() = view {
        id = "voiceAssistantManagementRootView"
        style { matchParentDimensions }
        scrollable {
            style { matchParentDimensions }
            verticalLayout {
                style {
                    width = matchParent
                    height = wrapContent
                    padding = 32.px
                }
                pageTitle()
                settingsSection()
            }
        }
    }

    private fun LinearLayout.pageTitle() {
        textView {
            text = "Voice Assistant".localized()
            style {
                width = wrapContent
                fontSize = 20.px
                fontWeight = "bold"
            }
        }
    }

    private fun LinearLayout.settingsSection() {
        verticalLayout {
            style {
                width = matchParent
                marginTop = 24.px
            }
            sectionTitle("Settings".localized())
            settingsForm = verticalLayout {
                style {
                    width = matchParent
                    marginTop = 12.px
                }
                withLoadingAndError(
                    uiState = viewModel.settingsUiState,
                    onRetryClicked = { viewModel.getSettings() },
                    onLoaded = { renderSettingsForm() },
                )
            }
        }
    }

    private fun renderSettingsForm() {
        val settings = viewModel.settings ?: return
        readSettingsIntoFields(settings)

        settingsForm?.apply {
            clearAllChildren()
            verticalLayout {
                style {
                    width = matchParent
                    this["gap"] = "12px"
                }
                isEnabledCheckBox = customCheckBox("Enabled for passengers".localized(), isSelected = isEnabled) {
                    isEnabled = it
                    if (it) checkModelsHealth()
                }
                engineDropDown()
                aiStandaloneSection = verticalLayout {
                    style {
                        width = matchParent
                        this["gap"] = "12px"
                    }
                    aiStandaloneBaseUrlInput = theme.labeledTextInput(this, "AI standalone base url".localized()) {
                        text = settings.aiStandaloneBaseUrl
                        placeholder = "http://127.0.0.1:8080/v1"
                    }
                    aiStandaloneApiKeyInput = theme.labeledTextInput(this, "AI standalone api key".localized()) {
                        element.type = "password"
                        element.autocomplete = "new-password"
                        placeholder = if (settings.hasAiStandaloneApiKey) "Saved".localized() else ""
                    }
                    aiStandaloneConfidenceSection = verticalLayout {
                        style {
                            width = matchParent
                            this["gap"] = "12px"
                        }
                        aiStandaloneHighConfidenceScoreInput = theme.labeledTextInput(this, "High confidence from score".localized()) {
                            text = settings.aiStandaloneHighConfidenceScore.toString()
                        }
                        aiStandaloneMediumConfidenceScoreInput = theme.labeledTextInput(this, "Medium confidence from score".localized()) {
                            text = settings.aiStandaloneMediumConfidenceScore.toString()
                        }
                        aiStandaloneLowConfidenceScoreInput = theme.labeledTextInput(this, "Low confidence from score".localized()) {
                            text = settings.aiStandaloneLowConfidenceScore.toString()
                        }
                        confidenceActionDropDown("On medium confidence".localized(), aiStandaloneMediumConfidenceAction) {
                            aiStandaloneMediumConfidenceAction = it
                        }
                        confidenceActionDropDown("On low confidence".localized(), aiStandaloneLowConfidenceAction) {
                            aiStandaloneLowConfidenceAction = it
                        }
                        engineDecisionConfidenceDropDown("When the engine confirms".localized(), aiStandaloneConfirmConfidence) {
                            aiStandaloneConfirmConfidence = it
                        }
                        engineDecisionConfidenceDropDown("When the engine hands off".localized(), aiStandaloneHandoffConfidence) {
                            aiStandaloneHandoffConfidence = it
                        }
                    }
                }
                enabledProfileGroupIdsInput = theme.labeledTextInput(
                    this, "Enabled passenger profile group ids".localized()
                ) { text = settings.enabledPassengerProfileGroupIds.joinToString(",") }
                verticalLayout {
                    theme.label(this, "Audio played before listening".localized(), isRequired = false)
                    introAudioUploader = audioUploader(defaultAudioUrl = settings.introAudioUrl)
                }
                maxRecordingSecondsInput = theme.labeledTextInput(this, "Max recording seconds".localized()) {
                    text = settings.maxRecordingSeconds.toString()
                }
                speechDetectorDropDown()
                customCheckBox(
                    "Start the recording timer when the passenger starts talking".localized(),
                    isSelected = isRecordingTimerStartedOnSpeech,
                ) { isRecordingTimerStartedOnSpeech = it }
                customCheckBox(
                    "Detect a silent microphone (held by another app)".localized(),
                    isSelected = isSilencedMicrophoneDetected,
                ) { isSilencedMicrophoneDetected = it }
                customCheckBox(
                    "Skip route confirmation on high confidence".localized(),
                    isSelected = isRouteConfirmationSkippedOnHighConfidence,
                ) { isRouteConfirmationSkippedOnHighConfidence = it }
                customCheckBox(
                    "Choose and book the ride on route confirmation".localized(),
                    isSelected = isRideBookedOnRouteConfirmation,
                ) { isRideBookedOnRouteConfirmation = it }
                openAiConfidenceActionsSection = verticalLayout {
                    style { width = matchParent }
                    confidenceActionDropDown("On medium confidence".localized(), mediumConfidenceAction) {
                        mediumConfidenceAction = it
                    }
                    confidenceActionDropDown("On low confidence".localized(), lowConfidenceAction) {
                        lowConfidenceAction = it
                    }
                }
                customCheckBox(
                    "Send automatically when the passenger stops talking".localized(),
                    isSelected = isSendOnSilenceEnabled,
                ) { isSendOnSilenceEnabled = it }
                silenceSecondsBeforeSendInput = theme.labeledTextInput(this, "Silence before sending (seconds)".localized()) {
                    text = settings.silenceSecondsBeforeSend.toString()
                }
                candidatesCountInput = theme.labeledTextInput(this, "Candidates shown to the passenger".localized()) {
                    text = settings.candidatesCount.toString()
                }
                searchResultsCountInput = theme.labeledTextInput(this, "Search results sent to the model".localized()) {
                    text = settings.searchResultsCount.toString()
                }
                transcriptionLanguageDropDown()
                openAiRequestTimeoutSecondsInput = theme.labeledTextInput(this, "Model request timeout (seconds)".localized()) {
                    text = settings.openAiRequestTimeoutSeconds.toString()
                }
                maxInterpretationsPerDayInput = theme.labeledTextInput(this, "Voice searches per passenger per day (0 = unlimited)".localized()) {
                    text = settings.maxInterpretationsPerDay.toString()
                }
                maxAudioBytesInput = theme.labeledTextInput(this, "Max audio payload bytes".localized()) {
                    text = settings.maxAudioBytes.toString()
                }
                audioRetentionHoursInput = theme.labeledTextInput(this, "Keep voice recordings for (hours)".localized()) {
                    text = settings.audioRetentionHours.toString()
                }
                openAiModelsSection = verticalLayout {
                    style {
                        width = matchParent
                        this["gap"] = "12px"
                    }
                    customCheckBox(
                        "Only look for the destination (ignore pickup)".localized(),
                        isSelected = isOnlyDestinationInterpreted,
                    ) { isOnlyDestinationInterpreted = it }
                    customCheckBox(
                        "Also send the recording to the AI standalone and give its results to the chat model".localized(),
                        isSelected = isAiStandaloneHintUsed,
                    ) {
                        isAiStandaloneHintUsed = it
                        showSectionsUsedByEngine()
                    }
                    chatFields?.run { render() }
                    transcriptionFields?.run { render() }
                    transcriptionFallbacksSection()
                    transcriptionPromptInput = theme.labeledTextInput(this, "Transcription hint (place vocabulary)".localized()) {
                        text = settings.transcriptionPrompt
                    }
                    maxToolCallRoundsInput = theme.labeledTextInput(this, "Max search rounds per request".localized()) {
                        text = settings.maxToolCallRounds.toString()
                    }
                    maxResponseTokensInput = theme.labeledTextInput(this, "Max response tokens".localized()) {
                        text = settings.maxResponseTokens.toString()
                    }
                    elasticsearchMcpUrlInput = theme.labeledTextInput(this, "CarApp Elasticsearch MCP url (empty = search in process)".localized()) {
                        text = settings.elasticsearchMcpUrl
                    }
                    elasticsearchMcpToolNameInput = theme.labeledTextInput(this, "CarApp Elasticsearch MCP tool name".localized()) {
                        text = settings.elasticsearchMcpToolName
                    }
                    checkMcpConnectionButton()
                    val defaultPrompts = viewModel.defaultPrompts
                    systemPromptInput = promptTextArea(
                        "System prompt ({{task}} {{language}} {{transcript}} {{rules}})".localized(),
                        settings.systemPrompt,
                        defaultPrompts?.systemPrompt,
                        rows = 24,
                    )
                    dropoffRulesInput = promptTextArea(
                        "{{rules}} when asked for the destination".localized(),
                        settings.dropoffRules,
                        defaultPrompts?.dropoffRules,
                    )
                    pickupRulesInput = promptTextArea(
                        "{{rules}} when asked for the pickup".localized(),
                        settings.pickupRules,
                        defaultPrompts?.pickupRules,
                    )
                    destinationOnlyRulesInput = promptTextArea(
                        "{{rules}} when only looking for the destination".localized(),
                        settings.destinationOnlyRules,
                        defaultPrompts?.destinationOnlyRules,
                    )
                    aiStandaloneHintSection = verticalLayout {
                        style { width = matchParent }
                        aiStandaloneHintPromptInput = promptTextArea(
                            "AI standalone results section ({{standaloneTranscript}} {{standalonePhrase}} {{standaloneDecision}} {{standalonePlaces}})".localized(),
                            settings.aiStandaloneHintPrompt,
                            defaultPrompts?.aiStandaloneHintPrompt,
                        )
                    }
                }
                showSectionsUsedByEngine()
                saveSettingsButton()
                engineTestSection()
            }
        }
        modelsHealthResults?.modelsSuspendedLine(settings.modelsSuspendedReason)
    }

    private fun readSettingsIntoFields(settings: VoiceAssistantSettingsDto) {
        isEnabled = settings.isEnabled
        speechDetector = settings.speechDetector.enum<VoiceAssistantSpeechDetector>()
        isSendOnSilenceEnabled = settings.isSendOnSilenceEnabled
        isRecordingTimerStartedOnSpeech = settings.isRecordingTimerStartedOnSpeech
        isSilencedMicrophoneDetected = settings.isSilencedMicrophoneDetected
        isRouteConfirmationSkippedOnHighConfidence = settings.isRouteConfirmationSkippedOnHighConfidence
        isRideBookedOnRouteConfirmation = settings.isRideBookedOnRouteConfirmation
        isOnlyDestinationInterpreted = settings.isOnlyDestinationInterpreted
        isAiStandaloneHintUsed = settings.isAiStandaloneHintUsed
        mediumConfidenceAction = settings.mediumConfidenceAction.enum<VoiceAssistantMediumConfidenceAction>()
        lowConfidenceAction = settings.lowConfidenceAction.enum()
        aiStandaloneMediumConfidenceAction = settings.aiStandaloneMediumConfidenceAction.enum()
        aiStandaloneLowConfidenceAction = settings.aiStandaloneLowConfidenceAction.enum()
        aiStandaloneConfirmConfidence = settings.aiStandaloneConfirmConfidence.enum()
        aiStandaloneHandoffConfidence = settings.aiStandaloneHandoffConfidence.enum()
        engine = settings.engine.enum<VoiceAssistantEngine>()
        chatFields = VoiceAssistantModelEndpointFields(
            role = VoiceAssistantModelRole.CHAT,
            roleName = "Chat".localized(),
            provider = settings.chatProvider.enum(),
            baseUrl = settings.chatBaseUrl,
            model = VoiceAssistantModels.chatModelOrDefault(settings.chatModel),
            hasStoredApiKey = settings.hasChatApiKey,
            temperature = settings.chatTemperature,
            isThinkingEnabled = settings.isChatThinkingEnabled,
            answersInSeparateStep = settings.chatAnswersInSeparateStep,
            defaultModel = VoiceAssistantModels.DEFAULT_CHAT_MODEL,
            loadListedModels = ::loadListedModels,
        )
        transcriptionFields = VoiceAssistantModelEndpointFields(
            role = VoiceAssistantModelRole.TRANSCRIPTION,
            roleName = "Transcription".localized(),
            provider = settings.transcriptionProvider.enum(),
            baseUrl = settings.transcriptionBaseUrl,
            model = VoiceAssistantModels.transcriptionModelOrDefault(settings.transcriptionModel),
            hasStoredApiKey = settings.hasTranscriptionApiKey,
            temperature = settings.transcriptionTemperature,
            isThinkingEnabled = null,
            answersInSeparateStep = null,
            defaultModel = VoiceAssistantModels.DEFAULT_TRANSCRIPTION_MODEL,
            loadListedModels = ::loadListedModels,
        )
        transcriptionFallbackEntries = settings.transcriptionFallbacks
            .map { newTranscriptionFallbackEntry(it) }
            .toMutableList()
        transcriptionLanguage =
            VoiceAssistantModels.transcriptionLanguageOrDefault(settings.transcriptionLanguage)
    }

    private fun newTranscriptionFallbackEntry(fallback: VoiceAssistantTranscriptionFallbackDto?) =
        TranscriptionFallbackEntry(
            VoiceAssistantModelEndpointFields(
                role = VoiceAssistantModelRole.TRANSCRIPTION,
                roleName = "Transcription fallback".localized(),
                provider = fallback?.provider?.enum() ?: VoiceAssistantModelProvider.OPENAI_COMPATIBLE,
                baseUrl = fallback?.baseUrl.orEmpty(),
                model = VoiceAssistantModels.transcriptionModelOrDefault(fallback?.model.orEmpty()),
                hasStoredApiKey = fallback?.hasApiKey ?: false,
                temperature = 0.0,
                isThinkingEnabled = null,
                answersInSeparateStep = null,
                defaultModel = VoiceAssistantModels.DEFAULT_TRANSCRIPTION_MODEL,
                loadListedModels = ::loadListedModels,
                isTuningOffered = false,
            ),
            isEnabled = fallback?.isEnabled ?: true,
        )

    private fun LinearLayout.transcriptionFallbacksSection() {
        sectionTitle("Transcription fallbacks".localized())
        transcriptionFallbacksView = verticalLayout {
            style {
                width = matchParent
                this["gap"] = "16px"
            }
        }
        transcriptionFallbackEntries.forEach { renderTranscriptionFallback(it) }
        theme.smallSecondaryButton(this) {
            text = "Add transcription fallback".localized()
            style { alignSelf = Alignment.Start }
            onClick = {
                val entry = newTranscriptionFallbackEntry(null)
                transcriptionFallbackEntries.add(entry)
                renderTranscriptionFallback(entry)
            }
        }
    }

    private fun renderTranscriptionFallback(entry: TranscriptionFallbackEntry) {
        transcriptionFallbacksView?.apply {
            entry.card = verticalLayout {
                style {
                    width = matchParent
                    this["gap"] = "12px"
                    this["border-left"] = "3px solid ${AppColors.redDark}"
                    this["padding-left"] = "12px"
                }
                customCheckBox("Enabled".localized(), isSelected = entry.isEnabled) { entry.isEnabled = it }
                entry.fields.run { render() }
                theme.smallSecondaryButton(this) {
                    text = "Remove".localized()
                    style { alignSelf = Alignment.Start }
                    onClick = {
                        entry.isRemoved = true
                        entry.card?.isVisible = false
                    }
                }
            }
        }
    }

    private fun TranscriptionFallbackEntry.toTranscriptionFallbackDto() = fields.run {
        VoiceAssistantTranscriptionFallbackDto(
            provider = provider.dto(),
            baseUrl = enteredBaseUrl,
            model = VoiceAssistantModels.transcriptionModelOrDefault(enteredModel),
            apiKey = enteredApiKey,
            hasApiKey = hasStoredApiKey,
            isEnabled = this@toTranscriptionFallbackDto.isEnabled,
        )
    }

    private class TranscriptionFallbackEntry(
        val fields: VoiceAssistantModelEndpointFields,
        var isEnabled: Boolean = true,
    ) {
        var card: LinearLayout? = null
        var isRemoved = false
    }

    private fun LinearLayout.speechDetectorDropDown() {
        setupLabeledDropDownList(
            name = "Speech detection".localized(),
            list = viewModel.speechDetectorOptions(),
            itemToString = { it.label() },
            defaultValue = speechDetector,
            onItemSelected = { selected -> selected?.let { speechDetector = it } },
        )
    }

    private fun LinearLayout.confidenceActionDropDown(
        name: String,
        selectedAction: VoiceAssistantMediumConfidenceAction,
        onActionSelected: (VoiceAssistantMediumConfidenceAction) -> Unit,
    ) {
        setupLabeledDropDownList(
            name = name,
            list = viewModel.mediumConfidenceActionOptions(),
            itemToString = { it.label() },
            defaultValue = selectedAction,
            onItemSelected = { selected -> selected?.let(onActionSelected) },
        )
    }

    private fun LinearLayout.engineDecisionConfidenceDropDown(
        name: String,
        selectedConfidence: VoiceAssistantEngineDecisionConfidence,
        onConfidenceSelected: (VoiceAssistantEngineDecisionConfidence) -> Unit,
    ) {
        setupLabeledDropDownList(
            name = name,
            list = viewModel.engineDecisionConfidenceOptions(),
            itemToString = { it.label() },
            defaultValue = selectedConfidence,
            onItemSelected = { selected -> selected?.let(onConfidenceSelected) },
        )
    }

    private fun VoiceAssistantEngineDecisionConfidence.label() = when (this) {
        VoiceAssistantEngineDecisionConfidence.HIGH -> "Treat as high confidence".localized()
        VoiceAssistantEngineDecisionConfidence.MEDIUM -> "Treat as medium confidence".localized()
        VoiceAssistantEngineDecisionConfidence.LOW -> "Treat as low confidence".localized()
        VoiceAssistantEngineDecisionConfidence.FROM_SCORE -> "Use the confidence from the score".localized()
    }

    private fun VoiceAssistantMediumConfidenceAction.label() = when (this) {
        VoiceAssistantMediumConfidenceAction.CONFIRM_ROUTE -> "Show the confirm route screen".localized()
        VoiceAssistantMediumConfidenceAction.OFFER_CALL_CENTER -> "Show a call center button".localized()
        VoiceAssistantMediumConfidenceAction.TRANSFER_TO_CALL_CENTER -> "Call the call center".localized()
    }

    private fun VoiceAssistantSpeechDetector.label() = when (this) {
        VoiceAssistantSpeechDetector.SILERO_MODEL -> "Silero speech model".localized()
        VoiceAssistantSpeechDetector.LOUDNESS -> "Loudness".localized()
    }

    private fun LinearLayout.engineDropDown() {
        setupLabeledDropDownList(
            name = "Engine".localized(),
            list = viewModel.engineOptions(),
            itemToString = { it.name },
            defaultValue = engine,
            onItemSelected = { selected ->
                selected?.let {
                    engine = it
                    showSectionsUsedByEngine()
                }
            },
        )
    }

    private fun showSectionsUsedByEngine() {
        val isStandalone = engine == VoiceAssistantEngine.AI_STANDALONE
        aiStandaloneSection?.isVisible = isStandalone || isAiStandaloneHintUsed
        aiStandaloneConfidenceSection?.isVisible = isStandalone
        openAiConfidenceActionsSection?.isVisible = isStandalone.not()
        aiStandaloneHintSection?.isVisible = isAiStandaloneHintUsed
        openAiModelsSection?.isVisible = isStandalone.not()
    }

    private fun LinearLayout.transcriptionLanguageDropDown() {
        setupLabeledDropDownList(
            name = "Transcription language".localized(),
            list = VoiceAssistantModels.transcriptionLanguages,
            itemToString = { it },
            defaultValue = transcriptionLanguage,
            onItemSelected = { selected -> selected?.let { transcriptionLanguage = it } },
        )
    }

    private fun LinearLayout.saveSettingsButton() {
        horizontalLayout {
            style {
                width = matchParent
                marginTop = 8.px
            }
            theme.mainButton(this) {
                text = "Save settings".localized()
                onClick = { saveSettings() }
                withLoadingAndError(
                    uiState = viewModel.upsertUiState,
                    onRetryClicked = { saveSettings() },
                    onLoaded = { saveStatusText?.text = "Voice assistant settings saved".localized() },
                )
            }
            theme.secondaryButton(this) {
                text = "Check models".localized()
                style { marginStart = 12.px }
                onClick = { checkModelsHealth() }
                withLoadingAndError(
                    uiState = viewModel.modelsHealthUiState,
                    onRetryClicked = { checkModelsHealth() },
                    onLoaded = { renderModelsHealth() },
                )
            }
            saveStatusText = textView {
                style {
                    width = wrapContent
                    marginStart = 12.px
                    alignSelf = Alignment.Center
                    color = AppColors.greenDark
                }
            }
            horizontalFiller()
        }
        modelsHealthResults = verticalLayout {
            style {
                width = matchParent
                marginTop = 8.px
                this["gap"] = "4px"
            }
        }
    }

    private fun LinearLayout.engineTestSection() {
        verticalLayout {
            style {
                width = matchParent
                marginTop = 24.px
                this["gap"] = "12px"
            }
            sectionTitle("Test the engine".localized())
            setupLabeledDropDownList(
                name = "Asked for".localized(),
                list = viewModel.fieldOptions(),
                itemToString = { it.label() },
                defaultValue = engineTestField,
                onItemSelected = { selected -> selected?.let { engineTestField = it } },
            )
            engineTestTextInput = theme.labeledTextInput(this, "Text instead of a recording".localized()) {
                style { direction = "auto" }
            }
            engineTestRecordingPicker()
            horizontalLayout {
                style { width = matchParent }
                theme.mainButton(this) {
                    text = "Run test".localized()
                    onClick = { testEngine() }
                    withLoadingAndError(
                        uiState = viewModel.engineTestUiState,
                        onRetryClicked = { testEngine() },
                        onLoaded = { showEngineTestResult() },
                    )
                }
                horizontalFiller()
            }
        }
    }

    private fun LinearLayout.engineTestRecordingPicker() {
        horizontalLayout {
            style {
                width = matchParent
                alignItems = Alignment.Center
                this["gap"] = "12px"
            }
            val recordingInput = input {
                isVisible = false
                type = "file"
                element.accept = "audio/*"
                element.onchange = { event ->
                    (event.target as HTMLInputElement).files?.get(0)?.let { file ->
                        val reader = FileReader()
                        reader.onload = {
                            engineTestRecording = EngineTestRecording(
                                fileName = file.name,
                                base64 = (reader.result as String).substringAfter(","),
                                mimeType = file.type.ifBlank { null },
                            )
                            engineTestTextInput?.text = ""
                            engineTestRecordingName?.text = file.name
                            Unit
                        }
                        reader.readAsDataURL(file)
                    }
                }
            }
            theme.secondaryButton(this) {
                text = "Choose a recording".localized()
                onClick = { recordingInput.element.click() }
            }
            engineTestRecordingName = textView {
                style { width = wrapContent }
            }
        }
    }

    private fun testEngine() {
        val edited = editedSettings() ?: return
        val typedTranscript = engineTestTextInput?.text?.trim()?.takeIf { it.isNotEmpty() }
        val recording = engineTestRecording.takeIf { typedTranscript == null }
        if (typedTranscript == null && recording == null) return
        viewModel.testEngine(edited, engineTestField, typedTranscript, recording)
    }

    private fun showEngineTestResult() {
        val turn = viewModel.engineTestTurn ?: return
        engineTestResultDialog.showTurn("Engine test".localized(), turn)
    }

    private fun VoiceAssistantField.label() = when (this) {
        VoiceAssistantField.PICKUP -> "Pickup".localized()
        VoiceAssistantField.DROPOFF -> "Destination".localized()
    }

    private fun LinearLayout.checkMcpConnectionButton() {
        horizontalLayout {
            style {
                width = matchParent
                alignItems = Alignment.Center
            }
            theme.secondaryButton(this) {
                text = "Check MCP connection".localized()
                onClick = { checkMcpHealth() }
                withLoadingAndError(
                    uiState = viewModel.mcpHealthUiState,
                    onRetryClicked = { checkMcpHealth() },
                    onLoaded = { renderMcpHealth() },
                )
            }
            mcpHealthResult = verticalLayout {
                style {
                    width = weightOf(1)
                    marginStart = 12.px
                }
            }
        }
    }

    private fun checkMcpHealth() {
        editedSettings()?.let { viewModel.checkMcpHealth(it) }
    }

    private fun renderMcpHealth() {
        val health = viewModel.mcpHealth ?: return
        mcpHealthResult?.apply {
            clearAllChildren()
            connectionHealthLine("CarApp Elasticsearch MCP".localized(), health)
        }
    }

    private fun loadListedModels(fields: VoiceAssistantModelEndpointFields) {
        val edited = editedSettings() ?: return
        val fallbackIndex = transcriptionFallbackEntries.filterNot { it.isRemoved }
            .indexOfFirst { it.fields === fields }
            .takeIf { it >= 0 }
        viewModel.listProviderModels(fields.role, edited, fallbackIndex, fields.listedModelsUiState) { listed ->
            fields.showListedModels(listed.models, listed.failure)
        }
    }

    private fun checkModelsHealth() {
        editedSettings()?.let { viewModel.checkModelsHealth(it) }
    }

    private fun renderModelsHealth() {
        val health = viewModel.modelsHealth ?: return
        isEnabledCheckBox?.run { if (health.isEnabled) check() else unCheck() }
        modelsHealthResults?.apply {
            clearAllChildren()
            connectionHealthLine("Chat".localized(), health.chat)
            connectionHealthLine("Transcription".localized(), health.transcription)
            modelsSuspendedLine(health.modelsSuspendedReason)
        }
    }

    private fun LinearLayout.modelsSuspendedLine(reason: String?) {
        reason ?: return
        textView {
            text = "${"Suspended for all passengers until the models pass a check".localized()}: $reason"
            style {
                width = matchParent
                color = AppColors.redDark
                fontWeight = "bold"
                this["word-break"] = "break-word"
            }
        }
    }

    private fun LinearLayout.connectionHealthLine(roleName: String, health: VoiceAssistantConnectionHealthDto) {
        textView {
            val status = if (health.isHealthy) "healthy".localized() else "failed".localized()
            text = listOfNotNull(
                "$roleName: $status",
                health.target,
                health.url,
                "${health.latencyMillis} ms",
                health.failure,
            ).joinToString(" - ")
            style {
                width = matchParent
                color = if (health.isHealthy) AppColors.greenDark else AppColors.redDark
                this["word-break"] = "break-word"
            }
        }
    }

    private fun saveSettings() {
        editedSettings()?.let { viewModel.saveSettings(it) }
    }

    private fun editedSettings(): VoiceAssistantSettingsDto? {
        val current = viewModel.settings ?: return null
        val chat = chatFields ?: return null
        val transcription = transcriptionFields ?: return null
        return VoiceAssistantSettingsDto(
                isEnabled = isEnabled,
                engine = engine.dto(),
                aiStandaloneBaseUrl = aiStandaloneBaseUrlInput?.text?.trim() ?: current.aiStandaloneBaseUrl,
                aiStandaloneApiKey = aiStandaloneApiKeyInput?.text?.trim().orEmpty(),
                hasAiStandaloneApiKey = current.hasAiStandaloneApiKey,
                aiStandaloneHighConfidenceScore = aiStandaloneHighConfidenceScoreInput.readDouble(current.aiStandaloneHighConfidenceScore),
                aiStandaloneMediumConfidenceScore = aiStandaloneMediumConfidenceScoreInput.readDouble(current.aiStandaloneMediumConfidenceScore),
                aiStandaloneLowConfidenceScore = aiStandaloneLowConfidenceScoreInput.readDouble(current.aiStandaloneLowConfidenceScore),
                aiStandaloneMediumConfidenceAction = aiStandaloneMediumConfidenceAction.dto(),
                aiStandaloneLowConfidenceAction = aiStandaloneLowConfidenceAction.dto(),
                aiStandaloneConfirmConfidence = aiStandaloneConfirmConfidence.dto(),
                aiStandaloneHandoffConfidence = aiStandaloneHandoffConfidence.dto(),
                enabledPassengerProfileGroupIds = parseProfileGroupIds(current.enabledPassengerProfileGroupIds),
                introAudioUrl = introAudioUploader?.audioUrl,
                maxRecordingSeconds = maxRecordingSecondsInput.readInt(current.maxRecordingSeconds),
                speechDetector = speechDetector.dto(),
                isSendOnSilenceEnabled = isSendOnSilenceEnabled,
                isRecordingTimerStartedOnSpeech = isRecordingTimerStartedOnSpeech,
                isSilencedMicrophoneDetected = isSilencedMicrophoneDetected,
                isRouteConfirmationSkippedOnHighConfidence = isRouteConfirmationSkippedOnHighConfidence,
                isRideBookedOnRouteConfirmation = isRideBookedOnRouteConfirmation,
                isOnlyDestinationInterpreted = isOnlyDestinationInterpreted,
                isAiStandaloneHintUsed = isAiStandaloneHintUsed,
                mediumConfidenceAction = mediumConfidenceAction.dto(),
                lowConfidenceAction = lowConfidenceAction.dto(),
                silenceSecondsBeforeSend = silenceSecondsBeforeSendInput.readInt(current.silenceSecondsBeforeSend),
                candidatesCount = candidatesCountInput.readInt(current.candidatesCount),
                searchResultsCount = searchResultsCountInput.readInt(current.searchResultsCount),
                chatProvider = chat.provider.dto(),
                chatBaseUrl = chat.enteredBaseUrl,
                chatModel = chat.enteredModel,
                chatApiKey = chat.enteredApiKey,
                hasChatApiKey = current.hasChatApiKey,
                chatTemperature = chat.enteredTemperature,
                isChatThinkingEnabled = chat.isThinkingEnabled ?: current.isChatThinkingEnabled,
                chatAnswersInSeparateStep = chat.answersInSeparateStep ?: current.chatAnswersInSeparateStep,
                transcriptionProvider = transcription.provider.dto(),
                transcriptionBaseUrl = transcription.enteredBaseUrl,
                transcriptionModel = transcription.enteredModel,
                transcriptionApiKey = transcription.enteredApiKey,
                hasTranscriptionApiKey = current.hasTranscriptionApiKey,
                transcriptionTemperature = transcription.enteredTemperature,
                transcriptionFallbacks = transcriptionFallbackEntries
                    .filterNot { it.isRemoved }
                    .map { it.toTranscriptionFallbackDto() }
                    .toTypedArray(),
                transcriptionLanguage = transcriptionLanguage,
                transcriptionPrompt = transcriptionPromptInput.readText(current.transcriptionPrompt),
                maxInterpretationsPerDay = maxInterpretationsPerDayInput.readInt(current.maxInterpretationsPerDay),
                maxAudioBytes = maxAudioBytesInput.readInt(current.maxAudioBytes),
                audioRetentionHours = audioRetentionHoursInput.readInt(current.audioRetentionHours),
                maxResponseTokens = maxResponseTokensInput.readInt(current.maxResponseTokens),
                elasticsearchMcpUrl = elasticsearchMcpUrlInput?.text?.trim() ?: current.elasticsearchMcpUrl,
                elasticsearchMcpToolName = elasticsearchMcpToolNameInput.readText(current.elasticsearchMcpToolName),
                openAiRequestTimeoutSeconds = openAiRequestTimeoutSecondsInput.readInt(current.openAiRequestTimeoutSeconds),
                maxToolCallRounds = maxToolCallRoundsInput.readInt(current.maxToolCallRounds),
                systemPrompt = systemPromptInput?.text ?: current.systemPrompt,
                dropoffRules = dropoffRulesInput?.text ?: current.dropoffRules,
                pickupRules = pickupRulesInput?.text ?: current.pickupRules,
                destinationOnlyRules = destinationOnlyRulesInput?.text ?: current.destinationOnlyRules,
                aiStandaloneHintPrompt = aiStandaloneHintPromptInput?.text ?: current.aiStandaloneHintPrompt,
                modelsSuspendedReason = current.modelsSuspendedReason,
            )
    }

    private fun LinearLayout.promptTextArea(label: String, prompt: String?, defaultPrompt: String?, rows: Int = 8): TextArea {
        val promptInput = theme.labeledTextArea(this, label) {
            text = prompt.orEmpty()
            element.rows = rows
            style {
                fontFamily = "monospace"
                fontSize = 12.px
                direction = "auto"
            }
        }
        defaultPrompt?.let { resetPromptButton(promptInput, it) }
        return promptInput
    }

    private fun LinearLayout.resetPromptButton(promptInput: TextArea, defaultPrompt: String) {
        theme.secondaryButton(this) {
            text = "Reset to default".localized()
            style {
                alignSelf = Alignment.Start
                marginTop = 4.px
            }
            onClick = { promptInput.text = defaultPrompt }
        }
    }

    private fun parseProfileGroupIds(fallback: Array<Int>): Array<Int> {
        val raw = enabledProfileGroupIdsInput?.text ?: return fallback
        if (raw.isBlank()) return emptyArray()
        return raw.split(",").mapNotNull { it.trim().toIntOrNull() }.toTypedArray()
    }

    private fun TextInput?.readInt(fallback: Int) = this?.text?.trim()?.toIntOrNull() ?: fallback
    private fun TextInput?.readDouble(fallback: Double) = this?.text?.trim()?.toDoubleOrNull() ?: fallback
    private fun TextInput?.readText(fallback: String) = this?.text?.trim()?.ifBlank { fallback } ?: fallback

    private fun LinearLayout.sectionTitle(title: String) {
        textView {
            text = title
            style {
                width = wrapContent
                fontSize = 16.px
                fontWeight = "bold"
            }
        }
    }
}
